import Form from './Form';

export default class DisableLoginForm extends Form {
    templateId() {
        return '#disableLoginFormTemplate';
    }

    data() {
        return '/dashboard/profile/ajax/disableLogin/get';
    }

    onLoad(container) {
        $('#disableLogin').change(function () {
            var formGroup = container.find('#disableLoginAccountEmail').closest('.form-group');
            if ($(this).is(':checked')) {
                formGroup.hide();
            } else {
                formGroup.show();
            }
        });
    }
}
